import { getDetailsRoute } from '../../routing/utils';
import { getAllConsignmentsData, getSummaryMetricsData } from '../../api/genericConsignmentView';
import { createRouteAll, createRoute, createRouteAllAddToTrip, createRouteAddToTrip,
  createManualTrip  } from '../../api/retailDashboard';
const defaultRetailStatusFilterOptions = [
  'reachedathub',
  'outfordelivery',
  'delivered',
  'attempted',
  'inscan_at_hub',
  'in_transit',
  'pickup_awaited',
  'pickup_scheduled',
  'out_for_pickup',
  'not_picked_up',
  'pickup_completed',
  'received',
  'not_received',
  'out_for_store_pickup',
];

const viewControl = {
  pageTitle : 'Consignments',
  buckets : [
    'retail_dc_all',
    'retail_dc_unplanned',
    'retail_dc_planned',
    'retail_dc_in_progress',
    'retail_dc_completed',
    'retail_dc_failed',
  ],
  navBar : {
    left : ['hub_search_with_type', 'date_filter'],
    right : ['search_redirect'],
  },
  globalActions:[],
  dateFilterOptions : [
    { key:'created_at', val:'Creation Time' },
    { key:'last_main_event_time', val: 'Last Updated' },
    { key:'scheduled_at', val: 'Scheduled At' },
    // { key:'hub_arrival_time', val: 'Hub Arrival Time' },
  ],
  searchFilterOptions : [
    { key:'referenceNumber', val: 'Reference Number' },
    // { key:'senderPhone', val: 'Sender Phone' },
    // { key:'destinationPhone', val: 'Receiver Phone' },
  ],
  hubSearchOptions : [
    { key:'dc', val:'Planning Hub' },
    { key:'upcountry', val:'Upcountry Hub' },
  ],
  detailsRoute:getDetailsRoute,
  fetchData : getAllConsignmentsData,
  fetchSummaryMetrics : getSummaryMetricsData,
  applyDateFilterSort: true,
};
const buckets = {
  retail_dc_all : {
    name:'All',
    filters : [
      'status',
      'attempt_count',
      'pickup_attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
      'customer_reference_number_search',
      'scheduledDate',
      'store_hub_id',
      'so_number_search',
      'destination_pincode_city',
      'delivery_type',
    ],
    actions : [
      'addCN',
      'delivery_note',
    ],
    status_filter: defaultRetailStatusFilterOptions,

  },
  retail_dc_planned : {
    hidePagination : false,
    hidePerPageCount :false,
    name:'Planned',
    filters : [
      'status',
      'attempt_count',
      'pickup_attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
      'customer_reference_number_search',
      'scheduledDate',
      'store_hub_id',
      'so_number_search',
      'destination_pincode_city',
      'delivery_type',
    ],
    actions : [
      // 'createRoute',
      'unassign',
      'hand_delivery',
      'delivery_note',
    ],
    status_filter: defaultRetailStatusFilterOptions,

  },
  retail_dc_unplanned : {
    hidePagination : false,
    hidePerPageCount :false,
    name:'Unplanned',
    filters : [
      'status',
      'attempt_count',
      'pickup_attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
      'customer_reference_number_search',
      'scheduledDate',
      'store_hub_id',
      'so_number_search',
      'destination_pincode_city',
      'delivery_type',
    ],
    actions : [
      'createCustomTrip',
      'createRoute',
      'addToTrip',
      'hand_delivery',
      // 'unassign',
      'delivery_note',
    ],
    actionsApiCalls : {
      create_route : {
        createRouteForAll: createRouteAll,
        createRouteForSelected: createRoute,
        bulkCreateRoute: createRoute,
      },
      add_to_existing : {
        createRouteForAll: createRouteAllAddToTrip,
        createRouteForSelected: createRouteAddToTrip,
        bulkCreateRoute: createRouteAddToTrip,
      },
      create_custom_trip: {
        createCustomTrip: createManualTrip,
      },
    },
    status_filter: defaultRetailStatusFilterOptions,

  },
  retail_dc_in_progress : {
    name: 'In Transit',
    filters : [
      'status',
      'attempt_count',
      'pickup_attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
      'customer_reference_number_search',
      'scheduledDate',
      'store_hub_id',
      'so_number_search',
      'destination_pincode_city',
      'delivery_type',
    ],
    actions: [
      'delivery_note',
    ],
    status_filter : defaultRetailStatusFilterOptions,
  },
  retail_dc_completed : {
    name: 'Success',
    filters : [
      'status',
      'attempt_count',
      'pickup_attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
      'customer_reference_number_search',
      'scheduledDate',
      'store_hub_id',
      'so_number_search',
      'destination_pincode_city',
      'delivery_type',
    ],
    actions: [
      'delivery_note',
    ],
    status_filter : defaultRetailStatusFilterOptions,
  },
  retail_dc_failed : {
    name: 'Failed',
    filters : [
      'status',
      'attempt_count',
      'pickup_attempt_count',
      'service_type',
      'load_type',
      'customer_code',
      'consignment_type',
      'proximity',
      'orderType',
      'purchasingGroup',
      'reference_number_search',
      'customer_reference_number_search',
      'scheduledDate',
      'store_hub_id',
      'so_number_search',
      'destination_pincode_city',
      'delivery_type',
    ],
    actions: ['moveFailedCns', 'delivery_note'],
    status_filter : defaultRetailStatusFilterOptions,
  },
};

const bucketColor = {
  retail_dc_all: '#EB2F96',
  retail_dc_planned: '#722ED1',
  retail_dc_unplanned: '#EB2F96',
  retail_dc_in_progress: '#2F54EB',
  retail_dc_completed: '#389E0D',
  retail_dc_failed : '#FA541C',
};

export default { viewControl, buckets, bucketColor };
